import { formatDate } from '@branch-messenger/willow-ui/utils'
import { createFileRoute } from '@tanstack/react-router'

import {
  ewaBranchVerificationQueryOptions,
  reportedEarningsQueryOptions,
  reportedHoursQueryOptions,
} from '@/queries/ewa'
import { orgInfoQueryOptions } from '@/queries/organization'
import { selectVerificationData } from '@/selectors/ewa'
import { selectOrgData } from '@/selectors/organization'

export const Route = createFileRoute(
  '/_authenticated/account/_dashboard/onDemandPay/reportedWork'
)({
  loader: async ({ context: { queryClient, orgStore } }) => {
    const data = queryClient.getQueryData(
      orgInfoQueryOptions(orgStore.getState()?.orgId).queryKey
    )
    const { usesEarnings } = selectOrgData(data)
    if (usesEarnings) {
      return queryClient.ensureInfiniteQueryData(reportedEarningsQueryOptions)
    }

    const verificationData = await queryClient.ensureQueryData(
      ewaBranchVerificationQueryOptions
    )
    const { nextPayRollDeadline, prevPayRollDeadline } =
      selectVerificationData(verificationData)

    if (!nextPayRollDeadline || !prevPayRollDeadline) {
      return
    }

    return queryClient.ensureInfiniteQueryData(
      reportedHoursQueryOptions({
        start_time: formatDate({
          date: prevPayRollDeadline,
          outputFormat: `yyyy-MM-dd'T'HH:mm:ss`,
        }),
        end_time: formatDate({
          date: nextPayRollDeadline,
          outputFormat: `yyyy-MM-dd'T'HH:mm:ss`,
        }),
      })
    )
  },
})
